import React from "react";
import DesignPrototypeCard from "./designPrototypeCard";
import ProjectSnapCarousel from "./projectSnapCarousel";
import Footer from "./footer";
import "../style/designPrototypeView.css";

const DesignPrototypeView = React.forwardRef(function DesignPrototypeView(
  { projectData = [], expanded = [], toggleDescription = () => {} },
  ref,
) {
  return (
    <section className="design-prototype-view" ref={ref}>
      <div className="design-prototype-heading">
        <h1 className="design-prototype-title">My Design Projects</h1>
      </div>

      <ProjectSnapCarousel
        items={projectData}
        footer={<Footer />}
        showBackToTop
        renderItem={(project, index, isActive) => (
          <DesignPrototypeCard
            image={project.image}
            images={project.images}
            title={project.title}
            languages={project.languages}
            description={project.description}
            link={project.link}
            isActive={isActive}
            layout={index % 2 === 0 ? "image-left" : "image-right"}
            isExpanded={!!expanded[index]}
            onToggle={() => toggleDescription(index)}
          />
        )}
      />
    </section>
  );
});

export default DesignPrototypeView;
